<div class="d-flex flex-column h-88 w-100 text-oninvert-high position-relative">
  <div class="d-flex flex-column text-oninvert-high p-plus header-text h-100">
    <span class="st-6">{{ config()!.title }}</span>
    <span class="c-2 subtitle">{{ config()!.subTitle }}</span>
  </div>
  @switch (config()?.imageType) {
    @case (ServiceImagesType.IMAGE_ID) {
      <ui-api-image
        [imageId]="config().image"
        [styles]="{ borderRadius: '20px', objectFit: 'cover' }"
        width="100%"
        height="100%"
        class="header-image"
      ></ui-api-image>
    }
    @default {
      <img
        [src]="config()?.image"
        class="header-image radius-plus"
      />
    }
  }
</div>
